<script lang="ts" setup>

import type { SearchContentType } from '../HeaderSearch.types';

type Props = {
    isLoading?: boolean;
    title: string;
    link?: string;
    data: SearchContentType[] | undefined;
};

defineProps<Props>();

</script>

<template>
  <div v-bind="$attrs"
       class="search-content"
  >
    <h5 v-if="data?.length"
        class="compact-400-default search-content__title"
    >
      {{ title }}
    </h5>
    <Transition name="fade"
                mode="out-in"
    >
      <div v-if="isLoading"
           key="loading"
      >
        <LoaderSkeleton v-for="(_, index) in Array(3)"
                        :key="index"
                        class="loading-helper"
                        :height="36"
        />
      </div>

      <div v-else-if="data?.length && !isLoading"
           key="content"
      >
        <NuxtLink v-for="(content, index) in data"
                  :key="index"
                  :to="content.link"
                  class="display-flex align-items-center search-content-row"
        >
          <div class="search-content-row__img">
            <ImgMain :src="content.imageUrl"
                     :alt="content.name"
            />
          </div>

          <div class="search-content-row__info">
            <span>{{ content.name }}</span>
            <span v-if="content.amount">&nbsp;{{ content.amount }} items</span>
          </div>
        </NuxtLink>
      </div>
      <div v-else-if="!isLoading && !data?.length">
        <span class="search-content__title">{{ title }} not found</span>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss">
.search-content {
  &__title {
    margin-bottom: $spacing-300;
    padding-left: $spacing-600;
    color: var(--content-secondary);
  }

  &-row {
    padding: $spacing-200 $spacing-600;
    transition: background-color 0.3s ease;
    background-color: transparent;

    &__info {
      margin-left: $spacing-200;
    }

    &__img {
      width: 36px;
      height: 36px;
    }

    &:hover {
      background-color: var(--bg-active-elements);
    }
  }

  &__icon {
    transform: rotate(-90deg)
  }

  &__more {
    padding-left: $spacing-600;
  }
}

.loading-helper {
  margin-right: $spacing-600;
  margin-bottom: $spacing-200;
  margin-left: $spacing-600;
}
</style>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
